import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

export default function Textures({navigateWithTransition}) {




return (

<div className="Textures">




</div>

)

}